import React, {useEffect} from 'react';
import ReactDom from "react-dom";
import Router from "./components/Misc/Router";
import "./resources/styles/index.scss";
import {Provider} from "react-redux";
import store from "./store";
import {onResize} from './services/actions/responsive';

const App = () => {

    useEffect(() => {
        const embedContentContainer = document.querySelector('#embedded-content');
        const observer = new ResizeObserver(() => {
            store.dispatch(onResize({
                width: embedContentContainer?.clientWidth,
                height: embedContentContainer?.clientHeight
            }));
        });

        if (!!embedContentContainer) {
            observer.observe(embedContentContainer);
        }
        return () => observer.disconnect();
    }, []);

    return (
        <Provider store={store}>
            <Router />
        </Provider>
    );
};

ReactDom.render(
    <div id={'embedded-content'}>
        <App />
    </div>,
    document.getElementById('root')
);

